import React, { Component } from "react";
import { Box, Flex, Spacer, HStack, Card, CardBody, Text, SimpleGrid } from '@chakra-ui/react';
import { DateTime } from "luxon";
import HealthCard from "./HealthCard.jsx";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartPulse, faArrowCircleDown, faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";

import HealthFunctions from "./HealthFunctions.js";

import "../../../../assets/css/healthfolder.css";

export default class HealthFolder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            overallHealthColor: "lightgrey",
            overallHealth: "Healthy",
            lastRefreshed: ""
        }
        this.refreshHealthInfo = this.refreshHealthInfo.bind(this);
        this.toggleFull = this.toggleFull.bind(this)
    }


    componentDidUpdate(prevProps) {
        if (prevProps.healthInfoTriggerKey !== this.props.healthInfoTriggerKey) {
            this.refreshHealthInfo();
        }
    }


    refreshHealthInfo() {
        var overallStatus = this.props.healthInfo.overallStatus();
        this.setState({
            overallHealthColor: overallStatus.iconColor,
            overallHealth: overallStatus.label,
            lastRefreshed: this.props.healthInfo.lastRefreshed
        });

    }

    toggleFull() {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        var hide = "none";
        if (this.state.open) {
            hide = "block"
        } else {
            hide = "none"
        }


        return (
            <div style={{ width: "100%" }}>
                <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>
                    <HStack>
                        <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Health</Text>
                        <Spacer />
                        <FontAwesomeIcon icon={(hide === "none") ? faArrowCircleDown : faArrowCircleUp} color="white" onClick={() => this.toggleFull()} />
                    </HStack>
                    <Card
                        overflow='hidden'
                        background='white'
                    >

                        <CardBody>
                            <HStack justify="left">
                                <Text className="lastCheckedText" fontSize='xs' style={{ fontStyle: "italic", color: "#898787bd" }}>Last Checked: {<br />} {this.state.lastRefreshed}</Text>
                                <Spacer />
                                <FontAwesomeIcon icon={faHeartPulse} color={this.state.overallHealthColor} size="2x" />
                                <Text>{this.state.overallHealth}</Text>
                                <Spacer style={{ margin: "-10%" }} />
                                <Spacer />

                            </HStack>

                        </CardBody>
                    </Card>


                    {/* <Flex wrap='wrap' display={hide}> */}
                    <SimpleGrid columns={[1, 2, 4]} >
                        <Box style={{backgroundColor: "white", borderRadius: "5px", margin:"20px", height: "fit-content" }} display={hide}>
                            <HealthCard
                                id="obs-api"
                                healthInfo={(this.props.healthInfo) ? this.props.healthInfo["coreHealth"] : null}
                                title="Core API"
                                healthInfoTriggerKey={this.props.healthInfoTriggerKey}
                            />
                        </Box>

                        <Box style={{backgroundColor: "white", borderRadius: "5px", margin:"20px", height: "fit-content" }} display={hide}>
                            <HealthCard
                                id="obs-db"
                                healthInfo={(this.props.healthInfo) ? this.props.healthInfo["coreDbHealth"] : null}
                                title="Core DB"
                                healthInfoTriggerKey={this.props.healthInfoTriggerKey}
                            />
                        </Box>

                        <Box style={{backgroundColor: "white", borderRadius: "5px", margin:"20px", height: "fit-content" }} display={hide}>
                            <HealthCard
                                id="auth-api"
                                healthInfo={(this.props.healthInfo) ? this.props.healthInfo["authHealth"] : null}
                                title="Auth API"
                                healthInfoTriggerKey={this.props.healthInfoTriggerKey}
                            />
                        </Box>

                        <Box style={{backgroundColor: "white", borderRadius: "5px", margin:"20px", height: "fit-content" }} display={hide}>
                            <HealthCard
                                id="authresource-api"
                                healthInfo={(this.props.healthInfo) ? this.props.healthInfo["authResourceHealth"] : null}
                                title="Auth Resource API"
                                healthInfoTriggerKey={this.props.healthInfoTriggerKey}
                            />
                        </Box>


                    </SimpleGrid>
                    {/* </Flex> */}
                </Box>
            </div>
        )

    }
}